import { Box, Collapse, Typography } from "@mui/material";
import { ReactNode } from "react";

type SettingRowProps = {
  label?: string;
  description?: ReactNode;
  help?: ReactNode;
  children: ReactNode;
  openCollapse?: boolean;
  collapseChildren?: ReactNode;
  stacked?: boolean;
};

export function SettingRow({
  label,
  description,
  help,
  children,
  openCollapse = false,
  collapseChildren = null,
  stacked = false,
}: SettingRowProps) {
  if (stacked) {
    return (
      <Box sx={{ pb: 2, borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 2 }}>
          {label && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                <Typography variant="body1">{label}</Typography>
                {description && (
                  <Typography variant="body2" color="text.secondary">
                    {description}
                  </Typography>
                )}
              </Box>
              {help && help}
            </Box>
          )}
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            {children}
          </Box>
        </Box>
        {openCollapse && (
          <Box sx={{ mt: 2, ml: 2 }}>
            {collapseChildren}
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{
      pb: 2,
      borderBottom: "1px solid rgba(255,255,255,0.08)",
    }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          pt: 2,
        }}
      >
        {label && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Typography variant="body1">{label}</Typography>
              {description && (
                <Typography variant="body2" color="text.secondary">
                  {description}
                </Typography>
              )}
            </Box>
            {help && help}
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: label ? "flex-end" : "flex-start",
            alignItems: "center",
            gap: 2,
            width: "fit-content",
            maxWidth: "600px"
          }}
        >
          {children}
        </Box>
      </Box>
      {openCollapse && (
        <Box sx={{ mt: 2, ml: 2 }}>
          {collapseChildren}
        </Box>
      )}
    </Box>
  );
}

export default SettingRow;
